/**
 * File: maApp.view.module.js
 */
(function(){
    angular
        .module('maApp.view', [
            'ui.bootstrap',
            'ui.grid',
            'ui.grid.edit',
            'ui.grid.cellNav',
            'ui.grid.rowEdit',
            'maApp.remoteRequests',
            'maApp.parse',
            'maApp.view.pages',
            'maApp.view.partials'
        ]);
})();